import { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "store/hooks";

export function QueryParamsManager() {
    const { activeSortParameter, activePaginationLimit, activePaginationPage, activeSearchIdParameter, activeSearchPhoneParameter, activeOperator, activeSelling} = useAppSelector(state => state.myProxiesAdminPage);


    const [queryParams, setQueryParams] = useSearchParams();

    const isFirstRender = useRef(true);

    useEffect(() => {
        setQueryParams((params) => {
            if (activeSortParameter) {
                params.set("sort", activeSortParameter)
            } else {
                params.delete("sort")
            }

            if (activeSearchIdParameter) {
                params.set("searchId", String(activeSearchIdParameter))
            } else {
                params.delete("searchId")
            }

            if (activePaginationLimit) {
                params.set("limit", String(activePaginationLimit))
            } else {
                params.delete("limit")
            }

            if (activePaginationPage) {
                params.set("page", String(activePaginationPage))
            } else {
                params.delete("page")
            }

            if (activeSearchPhoneParameter) {
                params.set("searchPhone", activeSearchPhoneParameter)
            } else {
                params.delete("searchPhone")
            }

            if (activeOperator) {
                params.set("operator", activeOperator)
            } else {
                params.delete("operator")
            }

            if (activeSelling) {
                params.set("selling", activeSelling)
            } else {
                params.delete("selling")
            }

            return params
        }, {
            replace: isFirstRender.current
        })

        isFirstRender.current = false;
    }, [activeSortParameter, activePaginationLimit, activePaginationPage, activeSearchIdParameter, activeSearchPhoneParameter, activeOperator, activeSelling]);

    return <></>
}